export { EventBus } from './eventBus';
export { mergeDeep } from './mergeDeep';

export const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

export const isAnObject = item => item === Object(item) && !Array.isArray(item);
